import Page from "webPage/Page";
import StickySection from "util/StickySection";

import Track from "util/Track";
import URLHelper from "base/URLHelper";
import {handleContentsModal} from "util/handleContentsModal";

Page.register('post-template-default', () => {

    let $stickySectionRight = $('.js-sticky-section-right');
    let $stickySectionLeft = $('.js-sticky-section-left');

    let $articlePlainContent = $('.js-article-plain-content');


    $(window).on('resize load', function(){
        if ($stickySectionRight.find('.js-sticky-header').outerHeight() < $(window).outerHeight() && $stickySectionRight.find('.js-sticky-header').outerHeight() < $articlePlainContent.outerHeight()) {
            new StickySection($stickySectionRight, 960);
        }

        if ($articlePlainContent.outerHeight() > $stickySectionLeft.find('.js-sticky-header').outerHeight()) {
            new StickySection($stickySectionLeft, 760);
        }
    });

    new Track($('.js-card-slider-wrap'), {
        classes: {
            block: "card-slider",
        },
    });

    let $window = $(window);

    let article_content_h2 = $('.js-article-content').find("h2");

    article_content_h2.each(function(index, element){
        createLink(element);
    });

    $("body").on("click", ".js-toc-link", function () {
        const $this = $(this);
        const $target = $($this.prop("hash"));

        $(".contents-list__list-item").removeClass("contents-list__list-item--active");
        $this.closest(".contents-list__list-item").addClass("contents-list__list-item--active");

        if ($target.length !== 1) {
            return true;
        }

        const offset = $target.offset().top;
        const currentWindowOffset = $(window).scrollTop();

        let targetOffset = offset - 30;

        let navHeight = $(".js-header").height();

        if (offset < currentWindowOffset) {
            targetOffset = targetOffset - navHeight;
        }

        $(window).scrollTop(targetOffset);
        $(window).trigger("scroll");
        return false;
    });

    let article_height = getArticleHeight();

    $window.on("scroll", function () {
        let scroll = $window.scrollTop();

        let width = (scroll / article_height) * 100;
        $(".js-progress-bar").find(".progress-bar__width").css({"width": width + "%"});

        let $active = null;
        let $links = $(".js-toc-link");

        for (let link of $links.get().reverse()) {
            const $link = $(link);
            const $target = $($link.prop("hash"));

            if ($target.length !== 1) {
                continue;
            }

            const offsetTop = $target.offset().top;

            if (offsetTop < (scroll + $(".js-header").height() + 50)) {
                $active = $link;

                break;
            }
        }

        $(".contents-list__list-item").removeClass("contents-list__list-item--active");
        if ($active !== null) {
            $active.closest(".contents-list__list-item").addClass("contents-list__list-item--active");
        }

    }).on("resize", function () {
        article_height = getArticleHeight();

        $window.trigger("scroll");
    });

    $window.trigger("scroll");
    handleContentsModal();
});

function getArticleHeight() {
    let article_height = $(".js-article-header").outerHeight() + $(".js-article-content").height();

    if ($(window).outerWidth() < 760) {
        article_height = article_height + $(".js-article-content-list").outerHeight();
    }

    return article_height;
}

function createLink(element) {
    let heading_text = $(element).text();
    let span_id = generateIdToUse(heading_text);

    $(".js-content-list").append((
        eotwJSXFactory('li', {className: "contents-list__list-item"}, [eotwJSXFactory('a', {href: '#' + span_id, className: "contents-list__list-link js-toc-link"}, [heading_text])])
    ));

    $(element).replaceWith(buildElement(heading_text, span_id));
}

function generateIdToUse(heading_text) {
    let base_id = URLHelper.slug(heading_text);
    let id = base_id;

    let i = 1;

    do {
        if ($("#" + id).length === 0) {
            return id;
        }

        id = base_id + '-' + i;
    } while (i++ <= 500);

    return base_id + '-' + Math.random();
}

function buildElement(heading_text, span_id) {
    return (
        eotwJSXFactory('h2', null, [
            eotwJSXFactory('span', {id: span_id}, [heading_text])
        ])
    );
}
